export default __webpack_public_path__ + "static/media/TT_Norms_Pro_ExtraBold.094fe638.ttf";